(function () {

    'use strict';

    angular.module('iplusjs.utils.vertrag', [
        'lodash',
        'iplusjs.config',
        'iplusjs.utils.misc',
        'iplusjs.utils.format'
    ])
    .service('VertragUtilsService', VertragUtilsService);

    VertragUtilsService.$inject = [
        '$log',
        '$http',
        '$q',
        'lodash',
        'MiscUtilsService',
        'FormatUtilsService',
        'AppConfig'
    ];
    function VertragUtilsService($log, $http, $q, _, MiscUtilsService, FormatUtilsService, AppConfig) {
        var that = this;

        that.existsVertragsnummer = existsVertragsnummer;
        that.existsVbnummer = existsVbnummer;
        function existsVertragsnummer(vertragsnummer, produkt, kompatibleProdukte, subtypenBeachten) {
            if (MiscUtilsService.isAtLeastOneEmpty(vertragsnummer, produkt)) {
                $q.resolve();
            }

            var serviceUrl,
                params = {};
            if (produkt === '25S') {
                serviceUrl = FormatUtilsService.replace(AppConfig.API.services.vertragHuWChecker, vertragsnummer);
            } else if (produkt === 'TIER_SCHUTZBRIEF') {
                serviceUrl = FormatUtilsService.replace(AppConfig.API.services.vertragTierSchutzbriefChecker, vertragsnummer);
            } else {
                serviceUrl = FormatUtilsService.replace(AppConfig.API.services.vertragPrdChecker, vertragsnummer, produkt);

                params.kompatibleProdukte = kompatibleProdukte || false;
                params.subtypenBeachten = subtypenBeachten || false;
            }

            return $http.get(serviceUrl, {
                cache: true,
                params: params
            }).then(function (response) {
                $log.debug('existsVertragsnummer SUCCESS', response);

                if (response.data === 'JA') {
                    return true;
                } else {
                    return $q.reject();
                }
            }).catch(function (error) {
                $log.debug('existsVertragsnummer FAILURE', error);
                return $q.reject();
            });
        }
        function existsVbnummer(vbnummer) {
            if (MiscUtilsService.isEmpty(vbnummer)) {
                $q.resolve();
            }

            var serviceUrl = FormatUtilsService.replace(AppConfig.API.services.versicherungsbestaetigungChecker, vbnummer);

            return $http.get(serviceUrl, {
                cache: true
            }).then(function (response) {
                $log.debug('existsVbnummer SUCCESS', response);

                if (response.data === 'JA') {
                    return true;
                } else {
                    return $q.reject();
                }
            }).catch(function (error) {
                $log.debug('existsVbnummer FAILURE', error);
                return $q.reject();
            });
        }
    }

})();
